import { ActionResult, ActionResultWithIds, EnrichDocumentsResult, SuccessfulEnrichment } from './types';

export const getEnrichmentApplierName = (actionResults: Array<ActionResultWithIds>): string | undefined =>
  getApprovedApplyResult(actionResults)?.payload.appliedBy.userName;

export const getEnrichmentSuggestion = (actionResults: Array<ActionResultWithIds>): SuccessfulEnrichment | undefined =>
  actionResults.find(
    (ar): ar is ActionResultWithIds & SuccessfulEnrichment =>
      ar.action === 'propose_enrichment' && 'enriched' in ar.payload && ar.payload.enriched.length > 0,
  );

export const getEnrichmentFailure = (
  actionResults: Array<ActionResultWithIds>,
): Extract<EnrichDocumentsResult, { status: 'failure' }> | undefined =>
  actionResults.find(
    (ar): ar is ActionResultWithIds & Extract<EnrichDocumentsResult, 'payload'> =>
      (ar.action === 'propose_enrichment' && 'enriched' in ar.payload && ar.payload.enriched.length === 0) ||
      (ar.action === 'propose_enrichment' && 'reason' in ar.payload && ar.payload.reason === 'no_matches_found'),
  );

export const hasAnyActionError = (actionResults: Array<ActionResultWithIds>): boolean =>
  actionResults.some((ar) => ar.status === 'error');

export const getPendingApprovalResultId = (actionResults: Array<ActionResultWithIds>): string | undefined =>
  actionResults.findLast((ar) => ar.action === 'apply_enrichment' && ar.status === 'pending_approval')?.id;

export const buildAgentName = (messageId: string, partnerId: string, isAdmin: boolean): string => {
  const baseName = `v2_${messageId}_${partnerId}`;
  return isAdmin ? `admin_${baseName}` : baseName;
};

export const convertJsonPathToFieldId = (jsonpath: string): string => jsonpath.replace(/\[(\d+)\]/g, '.$1');

const getApprovedApplyResult = (
  actionResults: Array<ActionResultWithIds>,
): (ActionResultWithIds & Extract<ActionResult, { action: 'apply_enrichment'; status: 'approved' }>) | undefined =>
  actionResults.find(
    (ar): ar is ActionResultWithIds & Extract<ActionResult, { action: 'apply_enrichment'; status: 'approved' }> =>
      ar.action === 'apply_enrichment' && ar.status === 'approved',
  );
